export { default } from './EmprestimoGarantiaCarroContratoPassoaPasso';
